import React from 'react';
import EventCancelledSystemMessageRow from './EventCancelledSystemMessageRow';
import EventStandardMessageRow from './EventStandardMessageRow';
import { withUnreadDivider } from './chatUnreadDivider';

export default function EventMessageRows({
  messages = [],
  activeAnchorMessageId = '',
  cancelledRowProps = {},
  buildStandardRowProps,
  resolveMessageSourceBadgeLabel,
  shouldShowMessageSourceBadge,
  formatDateTime,
  withAnnouncementScopeTitle = false,
  linkifyText,
  shouldHideMessage,
  unreadDividerMessageId = '',
}) {
  // messages は DESC(index0=最新)。column-reverse コンテナが視覚順(上=古い)へ反転する。
  return withUnreadDivider(messages.map((message) => {
      if (message?.isEventCancelledMsg) {
        return (
          <EventCancelledSystemMessageRow
            key={message.id}
            message={message}
            activeAnchorMessageId={activeAnchorMessageId}
            resolveMessageSourceBadgeLabel={resolveMessageSourceBadgeLabel}
            shouldShowMessageSourceBadge={shouldShowMessageSourceBadge}
            formatDateTime={formatDateTime}
            withAnnouncementScopeTitle={withAnnouncementScopeTitle}
            linkifyText={linkifyText}
            {...cancelledRowProps}
          />
        );
      }

      if (typeof shouldHideMessage === 'function' && shouldHideMessage(message)) {
        return null;
      }

      return (
        <EventStandardMessageRow
          key={message.id}
          message={message}
          activeAnchorMessageId={activeAnchorMessageId}
          resolveMessageSourceBadgeLabel={resolveMessageSourceBadgeLabel}
          shouldShowMessageSourceBadge={shouldShowMessageSourceBadge}
          formatDateTime={formatDateTime}
          {...(typeof buildStandardRowProps === 'function'
            ? buildStandardRowProps(message)
            : {})}
        />
      );
    }), messages, unreadDividerMessageId);
}
